import InnerImageZoom from "vue-inner-image-zoom";
import { nextTick } from "vue";

type ZoomInstance = {
    $refs?: {
        img?: unknown;
    };
};

type ZoomComponent = typeof InnerImageZoom & {
    methods?: {
        handleLoad?: (this: ZoomInstance, event: { target: HTMLImageElement }) => void;
        initialDragMove?: (this: ZoomInstance, pageX: number, pageY: number) => void;
    };
};

const zoomComponent = InnerImageZoom as ZoomComponent;
const originalHandleLoad = zoomComponent.methods?.handleLoad;
const originalInitialDragMove = zoomComponent.methods?.initialDragMove;

function callWhenFigureReady(instance: ZoomInstance, run: () => void) {
    if (instance.$refs?.img) {
        run();
        return;
    }

    nextTick(() => {
        if (instance.$refs?.img) {
            run();
        }
    });
}

if (originalHandleLoad) {
    zoomComponent.methods!.handleLoad = function handleLoadSafe(event) {
        callWhenFigureReady(this, () => {
            originalHandleLoad.call(this, event);
        });
    };
}

if (originalInitialDragMove) {
    zoomComponent.methods!.initialDragMove = function initialDragMoveSafe(
        pageX,
        pageY
    ) {
        callWhenFigureReady(this, () => {
            originalInitialDragMove.call(this, pageX, pageY);
        });
    };
}

export default zoomComponent;
